import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { AsyncPipe, NgClass } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ShDroppanelSelectComponent } from '../../../../elements/components/droppanel-select/droppanel-select.component';
import { ShIconComponent } from '../../../../elements/components/icon/icon.component';
import { ShClickOutsideDirective } from '../../../../elements/directives/click-outside/click-outside.directive';
import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { ShIndeterminateDirective } from '../../../directives/indeterminate.directive';
import { FormValue, FormValueState } from '../../../entities/form-value.entity';
import { ShFormCheckboxWithDropdownComplexBaseComponent } from '../base-complex/form-checkbox-with-dropdown-complex-base.component';
import { CheckboxSelectionFormValues, CheckboxSelectionValues } from '../entities/checkbox-selection-value.entity';

@Component({
    selector: 'sh-form-checkbox-with-dropdown-base',
    templateUrl: '../base-complex/form-checkbox-with-dropdown-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormCheckboxWithDropdownBaseComponent)],
    standalone: true,
    imports: [
        ShClickOutsideDirective,
        ShDroppanelSelectComponent,
        NgClass,
        ReactiveFormsModule,
        ShIndeterminateDirective,
        ShIconComponent,
        AsyncPipe
    ]
})
export class ShFormCheckboxWithDropdownBaseComponent<
    T = string
> extends ShFormCheckboxWithDropdownComplexBaseComponent<T> {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    propagateChange(fv: CheckboxSelectionFormValues<T>): void {
        const unwrapped: CheckboxSelectionValues<T> = {
            checkbox: FormValue.unwrap(fv.checkbox),
            selection: fv.selection
                .filter((formValue: FormValue<T>) => formValue.state === FormValueState.SET)
                .map((formValue: FormValue<T>) => FormValue.unwrap(formValue))
        };

        this.changeHandler(unwrapped);
        this.changeDetectorRef.detectChanges();
    }

    writeValue(obj: any): void {
        const wrapped: CheckboxSelectionFormValues<T> = {
            checkbox: FormValue.wrap(obj?.checkbox ?? null),
            selection: obj?.selection?.map((value: T) => FormValue.wrap(value) ?? [])
        };
        super.writeValue(wrapped);
    }
}
